export default __webpack_public_path__ + "static/1-b6ff7ba9e471d65bad5b5690809ccc7f.png";